import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import { StickyContainer, Sticky } from 'react-sticky';
import MainContext from 'context/main';

import Share from './share';
import TableOfContent from './table-of-content';

import styles from './content.module.scss';

const cx = classNames.bind(styles);

const Content = ({ content, innerHTML, uri, extraLinks }) => {
  const { isTableOfContent } = useContext(MainContext);

  return (
    <article className={cx('wrapper')}>
      <StickyContainer className="container">
        {innerHTML ? (
          <div
            className={cx('content', { isTableOfContent })}
            dangerouslySetInnerHTML={{ __html: innerHTML }}
          />
        ) : (
          <div className={cx('content', { isTableOfContent })}>{content}</div>
        )}

        <Sticky disableCompensation>
          {({ style, isSticky }) => (
            <div
              className={cx('share-wrapper', { visible: isSticky })}
              style={{ ...style, top: isSticky ? 120 : 0 }}
            >
              <Share uri={uri} />
            </div>
          )}
        </Sticky>

        {isTableOfContent && (
          <TableOfContent contentClassName={styles.wrapper} extraLinks={extraLinks} />
        )}
      </StickyContainer>
    </article>
  );
};

Content.propTypes = {
  content: PropTypes.string,
  innerHTML: PropTypes.string,
  uri: PropTypes.string.isRequired,
  extraLinks: PropTypes.arrayOf(
    PropTypes.shape({
      linkText: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

Content.defaultProps = {
  content: '',
  innerHTML: '',
  extraLinks: null,
};

export default Content;
